import React, { useContext } from 'react';
import { Col, Row } from 'react-bootstrap';
import ReactApexChart from "react-apexcharts";
import { useTranslation } from 'react-i18next';
import NoDataLayer from '../../../../../Common/NoDataLayer';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useGetBoardComponentInfoValuesDetail, useGetBoardComponentInfoValuesDetailCompare } from '../../../../../../hooks/services/sKPI/useOfBoard';
import MainAppContext from '../../../../../../MainAppContext';
import { useEffect } from 'react';
import { useRef } from 'react';
import { useBoolean } from '@fluentui/react-hooks';
import { Callout, FontWeights, Text, mergeStyleSets } from '@fluentui/react';

function ChartOriginal(props) {
  const { t } = useTranslation();
  const contextSite = useContext(MainAppContext);

    //Parametros de entrada.
    const { 
		inputParam_BoardId = null,
		inputParam_Height = null,
		inputParam_ReportMode = false,
		inputParam_Container = null,
    } = props;

	const [isCalloutVisible, { toggle: toggleIsCalloutVisible }] = useBoolean(false);
    const { _chart, _chartToCompare, _componentInfoData, _componentInfoToCompareData } = useSelector((state) => state.chartDataBoard);
    const { _updateBoardChart, _updateBoardChartCompare } = useSelector((state) => state.chartDataBoard);
    useGetBoardComponentInfoValuesDetail(
        inputParam_BoardId,
        _componentInfoData,
        contextSite.kpiModule.boardCalendarFilterConfig.value,
        _updateBoardChart)

    useGetBoardComponentInfoValuesDetailCompare(
		inputParam_BoardId,
		_componentInfoToCompareData,
		contextSite.kpiModule.boardCalendarFilterConfig.value,
		_updateBoardChartCompare)    

	const acronim_titles = {
		acronim_s1_real: { acronim: "S1-Real", text: t("data-lang-lbl-field-valueReal")},
		acronim_s1_valueGoalPercent: {acronim: "S1-GoalP", text: t("data-lang-lbl-field-valueGoalPercent")},
		acronim_s1_valueGoal: {acronim: "S1-Goal", text: t("data-lang-lbl-field-valueGoal")},

		acronim_s2_real: { acronim: "S2-R", text: `${_componentInfoData.variableName} - ${t("data-lang-lbl-field-valueReal")}`},
		acronim_s2_valueGoalPercent: {acronim: "S2-GoalP", text: `${_componentInfoData.variableName} - ${t("data-lang-lbl-field-valueGoalPercent")}`},
		acronim_s2_valueGoal: {acronim: "S2-Goal", text: `${_componentInfoData.variableName} - ${t("data-lang-lbl-field-valueGoal")}`},
	}

	const _base = [
		{
			name: acronim_titles.acronim_s1_real.acronim,
			type: "column",
			data: _chart !== null ? _chart[0].l_vals.map(({ displayValue }) => displayValue) : []
		},
		{
			name: acronim_titles.acronim_s1_valueGoalPercent.acronim,
			type: "line",
			data: _chart !== null ? _chart[0].l_vals.map(({ valueGoalPercent }) => valueGoalPercent) : []
		},
		{
			name: acronim_titles.acronim_s1_valueGoal.acronim,
			type: "line",
			data: _chart !== null ? _chart[0].l_vals.map(({ valueGoal }) => valueGoal) : [],
		}
	]

  	const listSeriesX = _chart ? _base : []

  	const listSeriesXToCompare = _chartToCompare && _chart ? [
		{
			name: acronim_titles.acronim_s2_real.acronim,
			type: "column",
			data: _chartToCompare[0].l_vals.map(({ displayValue }) => displayValue)
		},
		{
			name: acronim_titles.acronim_s1_valueGoalPercent.acronim,
			type: "line",
			data: _chartToCompare[0].l_vals.map(({ valueGoalPercent }) => valueGoalPercent)
		},
		{
			name: acronim_titles.acronim_s2_valueGoal.acronim,
			type: "line",
			data: _chartToCompare[0].l_vals.map(({ valueGoal }) => valueGoal)
		}
	].concat(_base) : []

  	const listSerieTimeY = _chart ? _chart[0].l_vals.map(({ serieTimeStr }) => serieTimeStr) : []
  
  	const _baseSerieNames = [
		{
			axisTicks: {
				show: true,
			},
			axisBorder: {
				show: true,
				color: '#1F7BE8'
			},
			labels: {
				style: {
				colors: '#1F7BE8',
				}
			},
			tooltip: {
				enabled: true
			},
			title: {
				text: acronim_titles.acronim_s1_real.acronim,
				style: {
				color: '#1F7BE8',
				}
			}
		},
		{
			axisTicks: {
				show: true,
			},
			axisBorder: {
				show: true,
				color: '#000099'
			},
			labels: {
				style: {
				colors: '#000099',
				},
				formatter: function (val) {
				return val.toFixed(0) + "%";
				}
			},
			opposite: true,
			title: {
				text: acronim_titles.acronim_s1_valueGoalPercent.acronim,
				style: {
				color: '#000099',
				}
			}   
		},
		{
			show: false,
			title: {
				text: acronim_titles.acronim_s1_valueGoal.acronim,
				style: {
				color: '#FF8000',
				}
			}
		}
	]

  	const listSerieNames = _baseSerieNames;

  	const listSerieNamesToCompare = _componentInfoToCompareData ? _baseSerieNames.concat(
	[
		{
			axisTicks: {
				show: true,
			},
			axisBorder: {
				show: true,
				color: '#69aa00'
			},
			labels: {
				style: {
					colors: '#69aa00',
				}
			},
			tooltip: {
				enabled: true
			},
			title: {
				text: acronim_titles.acronim_s2_real.acronim,
				style: {
					color: '#69aa00',
				}
			}
		},
		{
			axisTicks: {
				show: true,
			},
			axisBorder: {
				show: true,
				color: '#a33100'
			},
			labels: {
				style: {
					colors: '#a33100',
				},
				formatter: function (val) {
					return val.toFixed(0) + "%";
				}
			},
			opposite: true,
			title: {
					text: acronim_titles.acronim_s2_valueGoalPercent.acronim,
					style: {
						color: '#a33100',
					}
			}   
    	}
	]) : [];

	const title = (_componentInfoData !== null ? _componentInfoData.variableName : '') + (_componentInfoToCompareData !== null ? ' / ' + _componentInfoData.variableName : '');
	const subtitle = (_componentInfoData !== null ? _componentInfoData.um : '') + (_componentInfoToCompareData !== null ? ' / ' + _componentInfoData.um : '');

	const chartRef = useRef(null);

	useEffect(() => {
		try {
			if (_chart && _chartToCompare) {
				setTimeout(() => {
					const chart = chartRef.current.chart;
	
					chart.toggleSeries(acronim_titles.acronim_s1_valueGoalPercent.acronim)
					chart.toggleSeries(acronim_titles.acronim_s1_valueGoal.acronim)
					chart.toggleSeries(acronim_titles.acronim_s2_valueGoal.acronim)
					chart.toggleSeries(acronim_titles.acronim_s2_valueGoalPercent.acronim)
				}, "100");
			}
		} catch (error) {
			
		}
    }, [_chart, _chartToCompare]);

	const styles = mergeStyleSets({
		callout: {
			width: 320,
			maxWidth: '90%',
			padding: '20px 24px',
		},
		title: {
		  	marginBottom: 12,
		  	fontWeight: FontWeights.semilight,
		}
	});

	return  (
				<>
					{
						_chart ?
						<>
							<ReactApexChart
								ref={chartRef}
								type="line"
								series={ listSeriesXToCompare.length !== 0 ? listSeriesXToCompare : listSeriesX }
								options={{
									title: {
										text: inputParam_ReportMode ? "" : title,
										align: 'center',
									},
									subtitle: {
										text: inputParam_ReportMode ? "" : subtitle,
										align: 'center',
									},
									colors: listSeriesXToCompare.length !== 0 ? ['#1F7BE8', '#000099', '#FF8000', '#69aa00', '#a33100', '#ff02d7'] : ['#1F7BE8', '#000099', '#FF8000'],
									chart: {
										height: 350,
										type: 'line',
										stacked: false,
										toolbar: {
											tools: {
												customIcons: [{
													icon: `<i class="ms-Icon ms-Icon--FileComment" aria-hidden="true"></i>`,
													index: -1,
													title: t('data-lang-lbl-charttooltiplegend'),
													class: 'custom-legeng-chart',
													click: toggleIsCalloutVisible
												}]
											}
										}
									},
									dataLabels: {
										enabled: false
									},
									stroke: {
										width: listSeriesXToCompare.length !== 0 ? [2, 2, 2, 2, 2, 2] : [2, 2, 2],
										dashArray: [0, 0, 5]
									},
									xaxis: {
										categories: listSerieTimeY,
									},
									yaxis: listSerieNamesToCompare.length !== 0 ? listSerieNamesToCompare : listSerieNames,
									tooltip: {
										fixed: {
										enabled: true,
										position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
										offsetY: 30,
										offsetX: 60
										},
									},
									legend: {
										horizontalAlign: 'center',
										offsetX: 40
									},
									responsive: [{
										breakpoint: undefined,
										options: {},
									}]
								}}
								height={ ((JSON.parse(inputParam_Container.htmlContainer).h -1) * (inputParam_ReportMode === true ? 56 : 220)) }
							/>
							{isCalloutVisible &&
								<Callout
									role="dialog"
									gapSpace={0}
									target={`.custom-legeng-chart`}
									onDismiss={toggleIsCalloutVisible}
									setInitialFocus
									className={styles.callout}
								>
									<Text as="h1" block variant="xLarge"> { t('data-lang-lbl-chartlegend') } </Text>
									<Text className='pb-2' block variant="small">
										<Row>
											<Col className='col-auto'>
												<b>{`${acronim_titles.acronim_s1_real.acronim}:`}</b> {`${acronim_titles.acronim_s1_real.text}`}
											</Col>
										</Row>
										<Row>
											<Col className='col-auto'>
												<b>{`${acronim_titles.acronim_s1_valueGoal.acronim}:`}</b> {`${acronim_titles.acronim_s1_valueGoal.text}`}
											</Col>
										</Row>
										<Row>
											<Col className='col-auto'>
												<b>{`${acronim_titles.acronim_s1_valueGoalPercent.acronim}:`}</b> {`${acronim_titles.acronim_s1_valueGoalPercent.text}`}
											</Col>
										</Row>
									</Text>
									{
										_componentInfoToCompareData &&
										<Text block variant="small">
											<Row>
												<Col className='col-auto'>
													<b>{`${acronim_titles.acronim_s2_real.acronim}:`}</b> {`${acronim_titles.acronim_s2_real.text}`}
												</Col>
											</Row>
											<Row>
												<Col className='col-auto'>
													<b>{`${acronim_titles.acronim_s2_valueGoal.acronim}:`}</b> {`${acronim_titles.acronim_s2_valueGoal.text}`}
												</Col>
											</Row>
											<Row>
												<Col className='col-auto'>
													<b>{`${acronim_titles.acronim_s2_valueGoalPercent.acronim}:`}</b> {`${acronim_titles.acronim_s2_valueGoalPercent.text}`}
												</Col>
											</Row>
										</Text>
									}
								</Callout>
							}
						</> : <NoDataLayer display={ true } />
					} 
				</>
			);
}

ChartOriginal.propTypes = {
  	inputParam_BoardId: PropTypes.number.isRequired,
  	inputParam_Height: PropTypes.number,
  	inputParam_ReportMode: PropTypes.bool,
};

export default ChartOriginal;